import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('TimeLogFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getTimeLogList: function () {
            return $http.get(settings.ApiURL + settings.TimeLogURL);
        },
        getTimeLogTypeList: function () {
            return $http.get(settings.ApiURL + settings.TimeLogURL + "/timelogtypes");
        },
        getTimeLogById: function (TypeId, Id, Number) {
            return $http.get(settings.ApiURL + settings.TimeLogURL + "/" + TypeId + "/" + Id + "/" + Number);
        },        
        getNewTimeLog: function () {
            return $http.get(settings.ApiURL + settings.TimeLogURL + "/newtimelog");
        },
        saveTimeLog: function (timeLog) {
            return $http.put(settings.ApiURL + settings.TimeLogURL, timeLog);
        },        
        deleteTimeLog: function (TypeId, Id, Number) {
            return $http.delete(settings.ApiURL + settings.TimeLogURL + "/" + TypeId + "/" + Id + "/" + Number);
        }        
    };
}]);

app.controller('TimeLogController', ['$q', '$scope', 'TimeLogFactory', '$rootScope', 'settings', 'masterFactory',
                            function ($q, $scope, TimeLogFactory, $rootScope, settings, masterFactory) {
                $rootScope.pageTitle = "Time Log";
                $scope.timeLogList = [];
                $scope.timeLogTypeList = [];
                $scope.timeLog = {};
                $scope.originalTimeLog
                $scope.newtimeLog = {};
                $scope.priceGroupText = "";
                $scope.error = "";
                $scope.modelState = [];
                $scope.isFormVisible = false;
                $scope.pageSize = 20;                

                // Initialization - this runs on load
                var init = function (pageIndex) {
                    masterFactory.verifyAuthentication();

                    $('#loadingModal').modal({ backdrop: 'static' });
                    $q.all([
                        TimeLogFactory.getTimeLogList().success(function (data) {
                            $scope.timeLogList = data;
                            $scope.refreshGrid(0);
                        }).error(function (data, status) {
                            masterFactory.setError(status, data, $scope);
                        }),
                        TimeLogFactory.getTimeLogTypeList().success(function (data) {
                            $scope.timeLogTypeList = data;
                        }).error(function (data, status) {
                            masterFactory.setError(status, data, $scope);
                        }),
                        TimeLogFactory.getNewTimeLog().success(function (data) {
                            $scope.newtimeLog = data;
                        }).error(function (data, status) {
                            masterFactory.setError(status, data, $scope);
                        })
                    ]).then(function () {
                        $('#loadingModal').modal('hide');
                    });
                };

                init(0);

                // Grid renderers
                $scope.refreshGrid = function (PageIndex) {                   
                    $('#gridTimeLog').dxDataGrid({
                        dataSource: {
                            store: {
                                data: $scope.timeLogList,
                                type: 'array',
                                key: ["TimeLogType", "TimeLogId", "Number"]
                            }
                        },
                        noDataText: "No Time Logs Found",
                        showColumnLines: true,
                        showRowLines: false,
                        showBorders: true,
                        rowAlternationEnabled: false,
                        contentReadyAction: grdReadyAction,
                        selection: { mode: 'single' },
                        paging: {
                            pageSize: $scope.pageSize,
                            pageIndex: PageIndex
                        },
                        pager: {
                            showPageSizeSelector: true,
                            allowedPageSizes: [10, 20, 30]
                        },
                        filterRow: {
                            visible: true
                        },
                        groupPanel: {
                            visible: false,
                        },
                        columns: [                            
                            {
                                caption: 'No',
                                dataField: 'Number',
                                cssClass: 'Number',
                                alignment: 'center',
                                dataType: 'number',
                                width: 100
                            },
                            {
                                caption: 'Time Log',
                                dataField: 'TimeLogName',
                                cssClass: 'TimeLogName',
                                dataType: 'string',
                                alignment: 'center',
                                cellTemplate: function (container, options) {
                                    $('<span />')
                                    .text(options.data.TimeLogName)
                                    .append("</br>")
                                    .appendTo(container);
                                    container.addClass('grid-cell-align-left');                                    
                                }
                            }
                        ],
                        wordWrapEnabled: true,
                        selectionChanged: function (selectedRowsInfo) {
                            if (selectedRowsInfo.selectedRowsData[0] != null) {
                                $('#loadingModal').modal({ backdrop: 'static' });
                                TimeLogFactory.getTimeLogById(selectedRowsInfo.selectedRowsData[0].TimeLogType, selectedRowsInfo.selectedRowsData[0].TimeLogId, 
                                    selectedRowsInfo.selectedRowsData[0].Number).success(function (data) {
                                        $scope.timeLog = data;
                                        $scope.originalTimeLog = angular.copy(data);
                                        $scope.isFormVisible = true;
                                        $scope.isDeleteVisible = true;
                                        ToggleYellowToGreen();
                                        $rootScope.pageTitle = "Time Log";
                                }).error(function (data, status) {
                                    masterFactory.setError(status, data, $scope);
                                }).finally(function () {
                                    $('#loadingModal').modal('hide');
                                });
                            }
                        }
                    });
                };

                // Button click functions and submit form function
                $scope.addNewEntity = function () {
                    $rootScope.pageTitle = "New Time Log";
                    $scope.isFormVisible = true;
                    $scope.isDeleteVisible = false;
                    $scope.timeLog = angular.copy($scope.newtimeLog);                    
                    ToggleGreenToYellow();
                };

                $scope.confirmDeleteEntity = function () {
                    $scope.deletMessage = 'Are you sure you want to delete?';
                    $('#DeleteModal').modal({ backdrop: 'static' });
                };

                $scope.deleteEntity = function (value) {
                    $scope.error = '';
                    if (value == 0) {
                        $('#DeleteModal').modal('hide');
                    }
                    else if (value == 1) {
                        TimeLogFactory.deleteTimeLog($scope.timeLog.TimeLogType, $scope.timeLog.TimeLogId, $scope.timeLog.Number).success(function (data) {
                            TimeLogFactory.getTimeLogList().success(function (data) {
                                var dataGrid = $('#gridTimeLog').dxDataGrid('instance');
                                    var pageIndex = dataGrid.pageIndex();
                                    $scope.pageSize = dataGrid.pageSize();
                                    $scope.timeLogList = data;
                                    $scope.cancelForm();
                                    $scope.refreshGrid(pageIndex);
                                }).error(function (data, status) {
                                    masterFactory.setError(status, data, $scope);
                                }).finally(function () {
                                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Time Log successfully' });
                                });
                            }).error(function (data, status) {
                                masterFactory.setError(status, data, $scope);
                            }).finally(function () {
                                $('#DeleteModal').modal('hide');
                            });
                        
                    }
                };

                $scope.cancelForm = function () {
                    var dataGrid = $('#gridTimeLog').dxDataGrid('instance');
                    dataGrid.clearSelection();
                    $scope.isFormVisible = false;
                    $scope.timeLogForm.submitted = false;
                    $scope.closeModelStateErrors();
                    $scope.closeAlert();
                };

                $scope.reset = function (type) {
                    if (type == 'update') { // get db bankaccount and set to scope.bankaccount.
                        $('#loadingModal').modal({ backdrop: 'static' });
                        TimeLogFactory.getTimeLogById($scope.originalTimeLog.TimeLogType, $scope.originalTimeLog.TimeLogId, $scope.originalTimeLog.Number).success(function (data) {
                            $scope.timeLog = data;                            
                        }).error(function (data, status) {
                            masterFactory.setError(status, data, $scope);
                        }).finally(function () {
                            $('#loadingModal').modal('hide');
                            $scope.error = '';
                        });
                    }
                    else {
                        $scope.timeLog = angular.copy($scope.newtimeLog);
                    }
                    $scope.timeLogForm.$setPristine();
                    $scope.timeLogForm.submitted = false;
                    $scope.closeModelStateErrors();
                    $scope.closeAlert();
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Time Log details were reset' });
                };

                $scope.submitForm = function () {
                    $scope.error = '';
                    if ($scope.timeLogForm.$valid) {
                        $scope.saveEntity();
                        $scope.timeLogForm.submitted = false;
                    } else {
                        $scope.timeLogForm.submitted = true;
                    }
                };

                $scope.saveEntity = function () {
                    $('#loadingModal').modal({ backdrop: 'static' });
                    TimeLogFactory.saveTimeLog($scope.timeLog).success(function (data) {                        
                        $scope.closeModelStateErrors();                        
                        $scope.error = '';
                        TimeLogFactory.getTimeLogList().success(function (data) {                            
                            var dataGrid = $('#gridTimeLog').dxDataGrid('instance');
                            var pageIndex = dataGrid.pageIndex();
                            $scope.pageSize = dataGrid.pageSize();
                            $scope.timeLogList = data;
                            $scope.refreshGrid(pageIndex);                            
                        }).error(function (data, status) {
                            masterFactory.setError(status, data, $scope);
                        }).finally(function () {
                            if ($scope.timeLog.TimeLogId > 0) {
                                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Time Log successfully' });
                            }
                            else {
                                $scope.cancelForm();
                                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Time Log successfully' });
                            }
                        });
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#loadingModal').modal('hide');
                    });
                };

                // Helping functions and events
                $(window).resize(function () {
                    onWindowResize('#gridCustomer', settings.GridMarginHeight);
                });

                function grdReadyAction(e) {
                    onWindowResize('#gridCustomer', settings.GridMarginHeight);
                };

                $scope.closeAlert = function () {
                    $scope.error = null;
                };

                $scope.closeModelStateErrors = function () {
                    $scope.modelState = [];
                };
            }]);